// extracted by mini-css-extract-plugin
export default {"wrapper":"siteNotFound_wrapper__IvS86","content":"siteNotFound_content__yp1eu","icon":"siteNotFound_icon__RJ75q"};